<div class="container" id="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Stammdatenreport</h4>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 ">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2"
                    (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="processType">
                            Typ
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.processType | translateExportType}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                            Dateiname
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="size">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="size">
                            Größe
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.size}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="lastModified">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="lastModified">
                            Vom
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.lastModified | date : 'dd.MM.YYYY HH:mm'}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="downloadReport(element.name)">
                                    <span>Herunterladen</span>
                                </button>
                            </mat-menu>

                        </td>
                    </ng-container>



                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <button class="fabAddBtnBottomRight" matTooltip="Report starten" mat-fab color="accent" (click)="startReport()">
                    <mat-icon>add</mat-icon>
                </button>

                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
                    passenden
                    Einträge
                    gefunden...</span>
            </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>